/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_ManualInputs */

const fr_tab_manual = /** @type {(inputs: Tab_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montage manuel`)
};

const en_tab_manual = /** @type {(inputs: Tab_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual mount`)
};

/**
* | output |
* | --- |
* | "Manual mount" |
*
* @param {Tab_ManualInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const tab_manual = /** @type {((inputs?: Tab_ManualInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_ManualInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tab_manual(inputs)
	return en_tab_manual(inputs)
});